import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  max-width: 100%;
  margin: 0;
`;

export const FormSection = styled.div`
  background: ${({ theme }) => theme.palette[10]};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
  border: 1px solid ${({ theme }) => theme.palette[100]};
`;

export const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const FormColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 30px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const PriceDisplay = styled.div`
  background: ${({ theme }) => theme.palette[50]};
  border: 1px solid ${({ theme }) => theme.palette[200]};
  border-radius: 6px;
  padding: 15px;
  margin-top: 20px;
  text-align: right;
  
  p {
    margin: 0;
    font-weight: 500;
    color: ${({ theme }) => theme.palette[900]};
  }
`;

export const ConfigOptionsContainer = styled.div`
  margin-top: 15px;
`;

export const ConfigOptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.palette[200]};
  border-radius: 6px;
  margin-bottom: 10px;
  background: ${({ theme }) => theme.palette[20]};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ConfigOptionsSection = styled.div`
  background: ${({ theme }) => theme.palette[10]};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
  border: 1px solid ${({ theme }) => theme.palette[100]};

  h2 {
    margin-bottom: 15px;
  }
`;

export const DateTimeRow = styled.div`
  display: flex;
  gap: 15px;
  align-items: flex-end;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ClearButton = styled.button`
  padding: 8px 16px;
  background: ${({ theme }) => theme.palette[200]};
  border: 1px solid ${({ theme }) => theme.palette[300]};
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette[900]};
  transition: all 0.2s;
  height: 40px;
  margin-bottom: 2px;

  &:hover {
    background: ${({ theme }) => theme.palette[300]};
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 0;
  }
`;



